<template>
    <div class="blog-category__item">
      <a class="blog-category__link"
        :href="categoria.url"
        :title="categoria.nombre">
        <p class="blog-category__text">{{ categoria.nombre }}</p>
      </a>
    </div>
</template>
<script>
    export default {
        name:'categoria-item',
        props: ['categoria'],
    }
</script>


// WEBPACK FOOTER //
// src/modules/blog/ara/components/categoriaItem.vue